import React, { useState } from 'react';
import { Button, Card, Flex, Modal, message, Tooltip, Switch } from 'antd';
import { EditOutlined, EllipsisOutlined, SettingOutlined, QrcodeOutlined, LinkOutlined, CopyOutlined } from '@ant-design/icons';
import CardContent from './card-content';
import { openWxminiShop } from './tools';
import clipboard from '../../utils/clipboard';
import { base62Encode, OFFSET } from '../../utils/base62';

export default ({content = {}}) => {
    const imageUrlPrefix = '//img.yxdj.tech/';
    const {
        shopId,
        accId,
        title,
        logoUrl,
        shopType,
        status,
        wxQrcodeUrl,
        contactPhoneNo,
        description,
        isHead,
    } = content;

    const [miniLinkOpen, setMiniLinkOpen] = useState(false);
    const [isFromHead, setIsFromHead] = useState(false);

    const CardHeader = () => {
        return (
            <Flex justify="space-between">
                <Flex gap={10}>
                    <img style={{width: 30, height: 30}} src={`${imageUrlPrefix}${logoUrl}?x-oss-process=image/resize,w_200`} alt="logo" />
                    <div style={{maxWidth: '225px', overflow: 'hidden', textOverflow: 'ellipsis'}}>{title || '默认店铺'}{isHead && '(总店)'}</div>
                </Flex>
                <Flex gap={10} align='center'>
                    <Tooltip title="获取小程序链接"><div onClick={() => onGetMiniLink(shopId)}><CopyOutlined /></div></Tooltip>
                    <div onClick={() => onQrcodeClick(shopId)}><QrcodeOutlined /></div>
                    <a onClick={() => onWxminiUrlClick(shopId)}><LinkOutlined /></a>
                </Flex>
            </Flex>
        )
    }

    const getQrcode = async (shopId) => {
        const response = await fetch(`/api/shop/qrcode?shopId=${shopId}`);
        const result = await response.json();

        if(result.success) {
            // setQrcode(result.data);
            // setIsQrcodeOpen(true);
            return result.data;
        } else {
            message.error(result.data);
        }
    }

    const updateQrcode = async (shopId) => { 
        const data = await getQrcode(shopId);

        const response = await fetch(`/api/shop/edit?shopId=${shopId}`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                wxQrcodeUrl: data.url
            })
        });

        const result = await response.json();

        if(result && result.success) {
            message.success('更新成功');
            window.location.reload();
        } else {
            message.error(result.data);
        }
    };

    const onQrcodeClick = async (shopId) => {
        // const wxQrcodeUrl  = await getQrcode(shopId);
        // console.log(wxQrcodeUrl);
        Modal.info({
            icon: null,
            title: '二维码',
            content: <div style={{ textAlign: 'center'}}>
                <img width={120} src={`${imageUrlPrefix}${wxQrcodeUrl}`} />
                <div style={{textAlign: 'center'}}><Button onClick={() => updateQrcode(shopId)}>更新二维码</Button></div>
            </div>
        });
    };

    const onWxminiUrlClick = async () => {
        await openWxminiShop(accId, shopId)
    }

    // 获取本店优选到家小程序短链：https://yxdj.tech/_{base62(shopId)}
    // 该链接 302 跳转到小程序首页，可在短信/分享中使用，不依赖微信 token 时效
    // 勾选「总公司渠道」时混编 OFFSET（shopId + 1e12，path 长度不变），短信渠道可带 isFromHead
    const onGetMiniLink = (shopId) => {
        setIsFromHead(false);
        setMiniLinkOpen(true);
    }

    const miniLink = isFromHead
        ? `https://yxdj.tech/_${base62Encode(Number(shopId) + OFFSET)}`
        : `https://yxdj.tech/_${base62Encode(shopId)}`;

    const requestDelete = async (shopId) => {
        const response = await fetch(`/api/shop/del`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                shopId,
            }),
        });
        const result = await response.json();
        if(result.success) {
            message.success('删除成功');
        } else {
            message.error(result.data);
        }

        return result;
    }

    const onDelete = async (shopId) => {
        Modal.confirm({
            title: '确定删除该店铺？',
            content: '删除后将无法恢复',
            onOk: () => {
                requestDelete(shopId).then(result => {
                    
                })
            }
        });
    }

    return (
        <>
            <Card title={<CardHeader />} style={{minWidth: 360, maxWidth: 456, width: '100%'}}
                actions={[
                    <a href={`/shop/create?accId=${accId}&shopId=${shopId}`}><EditOutlined key="edit" /> 编辑</a>,
                    // <a href=""><SettingOutlined key="setting" /> 禁用</a>,
                    <div onClick={() => onDelete(shopId)}><EllipsisOutlined key="ellipsis"  /> 删除</div>,
                ]}
            >
                <CardContent content={content} />
            </Card>
            <Modal
                open={miniLinkOpen}
                onCancel={() => setMiniLinkOpen(false)}
                footer={null}
                title='优选到家小程序链接'
            >
                <div style={{ textAlign: 'center' }}>
                    <div style={{ wordBreak: 'break-all', marginBottom: 16 }}>{miniLink}</div>
                    <div style={{ marginBottom: 16 }}>
                        <Switch
                            checked={isFromHead}
                            onChange={setIsFromHead}
                            checkedChildren="总公司渠道"
                            unCheckedChildren="普通"
                        />
                        <span style={{ marginLeft: 8 }}>总公司渠道(isFromHead)</span>
                    </div>
                    <Button type="primary" onClick={() => clipboard(miniLink, '小程序链接已复制，发送给客户即可打开本店小程序')}>复制链接</Button>
                </div>
            </Modal>
        </>
    )
}